export function searchObject(object, matchCallback, currentPath, result, searched, propsToSet) {
	const currPath = currentPath || '';
	const res = result || [];
	const search = searched || [];
	if (search.indexOf(object) !== -1 && object === Object(object)) {
		return;
	}
	search.push(object);
	if (matchCallback(object)) {
		//object.props = JSON.parse(JSON.stringify(propsToSet));
		res.push({ path: currPath, value: object });
	}
	try {
		if (object === Object(object)) {
			for (var property in object) {
				if (property.indexOf('$') !== 0) {
					//if (Object.prototype.hasOwnProperty.call(object, property)) {
					searchObject(object[property], matchCallback, currPath + '.' + property, res, search, propsToSet);
					//}
				}
			}
		}
	} catch (e) {
		console.log(object);
		throw e;
	}
	return res;
}
